import { useState } from 'react';
import Hero from './components/Hero';
import Origin from './components/Origin';
import Mission from './components/Mission';
import CoreValues from './components/CoreValues';
import Eligibility from './components/Eligibility';
import Support from './components/Support';
import Selection from './components/Selection';
import Application from './components/Application';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#F5F1E8]">
      <Navbar />
      <Hero />
      <Origin />
      <Mission />
      <CoreValues />
      <Eligibility />
      <Support />
      <Selection />
      <Application />
      <Contact />
      <Footer />
    </div>
  );
}
